import React, { useEffect, useState, useContext } from 'react'
// eslint-disable-next-line
import { Link, useHistory, useParams } from 'react-router-dom'
import { getAlbumById, getSonglistURL } from '../../utils/api'
import { getTime } from '../../utils/convert-time'
// eslint-disable-next-line
import { getDateFormat } from '../../utils/helper-functions'
import { useMusicPlayer } from '../../hooks/useMusicPlayer'
import { AccordianComp } from '../helpers/ChakraAccordian'
import { MusicPlayerContext } from '../../context/MusicPlayerContext'
import { Flex, Heading, Box } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { RiHeartLine, RiMore2Line, RiPlayLine, RiPauseLine } from 'react-icons/ri'
import { BackgroundBanner } from '../helpers/BackgroundBanner'

/***Album Details by ID***/
export const ByAlbum = ( { match } ) => {
  const { params: { id } } = match
  // const _id = useParams()
  // console.log(_id)
  const [album, setAlbum] = useState( {} )
  const [tracks, setTracks] = useState( [] )
  const [toggle, setToggle] = useState( true )
  const { playTrack, isPlaying, currentTrackName, currentTrack, trackList } = useMusicPlayer()
  const [state, setState] = useContext( MusicPlayerContext )
  const onToggle = () => setToggle( !toggle )

  const [showTrackNumber, shouldShowTrackNumber] = useState( true )
  // shouldShowTrackNumber( !showTrackNumber )
  const history = useHistory()
  const { i18n } = useTranslation( ['album', 'chartlist'], { useSuspense: false } )
  //console.log( i18n?.options?.resources?.album['en-US'], "byAlbum i18" )

  useEffect( () => {
    let ids
    const albumDetails = async () => {
      const res = await getAlbumById( id )
      // console.log( res, "albums-by-id" )
      setAlbum( res )
      let songIds = res.songs.map( song => song.id )
      ids = songIds
      const songURLs = await getSonglistURL( ids )
      let songsArr = res.songs.map( ( song, i ) => {
        songURLs.map( url => {
          if ( url.id === song.id ) {
            song.url = url.url
          }
          return url
        } )
        return song
      } )
      setTracks( songsArr )
    }
    albumDetails( id )
  }, [id] )

  const playCurrentTrack = ( index ) => {
    let current = tracks[index]
    let tracksArr = [...state.tracks, current]
    let deduped = [...new Set( tracksArr )]
    // console.log( "deduped/new Set: ", deduped )
    let idx = deduped.findIndex( track => track.id === current.id )
    state.tracks = deduped
    if ( idx !== -1 ) {
      playTrack( idx )
      setState( state => ( { ...state, currentTrackIndex: idx } ) )
    } else {
      console.log( "already queued" )
      setState( state => ( { ...state, currentTrackIndex: index } ) )
      // state.audioPlayer.pause()
    }
  }

  const Labels = [
    "环球唱片",
    "索尼音乐",
    "华纳音乐",
    "独立发行"
  ]
  const translateLabel = ( str ) => {
    Labels.forEach( ( label, i ) => {
      if ( Object.values( al ).includes( label ) ) {
        // console.log( label, "label&&index", i )
        let translations = i18n?.options?.resources?.album['en-US']?.map( ( company, index ) => {
          // console.log( i === index, "label === true", str )
          if ( i === index ) {
            for ( let key in company ) {
              // console.log( "company[key]: ", company[key] )
              str = company[key]
            }
          }
          return company
        } )
        // console.log( label, "label after after", i, translations[i]?.name )
      }
    } )
    return str
  }
  const al = album.album
  // console.log( al, album )
  return (
    <Box className="banner__main">
      <Flex
        w="100%"
        bg="alpha.black"
        wrap="wrap"
        h="auto">
        <BackgroundBanner {...album} />
        {al
          ? <div className="cards__container">
            <div key={al.id} className="playlists__inner details">
              <Heading fontWeight="hairline">
                <Link to={`/album/${al.id}`}>
                  {al?.name}
                </Link>
              </Heading>
              <Heading fontWeight="hairline" fontSize="lg">
                <Link to={`/artists/${al.artist.id}`}>
                  {al?.artist?.name}
                </Link>
              </Heading>
              <p>
                Label{"> "}
                <span>
                  {al?.company ? translateLabel( al?.company ) : al?.company}
                </span>
              </p>
              {al?.artists?.map( ( artist, i ) => {
                return <Link key={i} to={`/artists/${artist.id}`}>
                  <p>{artist.name}</p>
                </Link>
              } )}
              <p>{getDateFormat( al.publishTime )}</p>
            </div>
          </div>
          : null
        }

        <article className="list__wrapper">
          <AccordianComp
            header="Album Tracks"
            onToggle={onToggle}
          />
          <table id="album__detailsList">
            {toggle ? tracks && tracks.map( ( track, index ) => {
              return (
                <tbody key={track.id} id="album__listBody">
                  <tr className="queue__item">
                    <td className="queue__item tracknr">
                      {index + 1}
                    </td>
                    <td className="queue__item title">
                      <Link to={`/song/${track.id}`}>
                        <p>{track.name}</p>
                        <span>
                          {track?.ar?.map( ( { name } ) => name ).join( " & " )}
                        </span>
                      </Link>
                    </td>
                    <td className="queue__item play">
                      <button
                        type="button"
                        className="queue__item btn"
                        key={track.id}
                        onClick={() => playCurrentTrack( index )}
                      >
                        {currentTrackName === track.name && currentTrack.id === track.id && isPlaying
                          ? <RiPauseLine
                            className="paus__btn"
                          />
                          : <RiPlayLine className="play__btn"
                          />
                        }
                      </button>
                    </td>
                    <td className="queue__item length">
                      {getTime( track.dt )}
                    </td>
                    <td className="queue__item svg">
                      <RiHeartLine
                        style={{
                          width: "0.9em",
                          height: "0.9em"
                        }}
                      />
                    </td>
                    <td className="queue__item svg">
                      <RiMore2Line />
                    </td>
                  </tr>
                </tbody>
              )
            } )
              : null
            }
          </table>
        </article>
      </Flex>
    </Box>
  )
}